module.exports = window.__IFENG_EXTERNALS__["intersection-observer"];